import { render, staticRenderFns } from "./RgpMaterials.vue?vue&type=template&id=2d6ad392&scoped=true&"
import script from "./RgpMaterials.vue?vue&type=script&lang=js&"
export * from "./RgpMaterials.vue?vue&type=script&lang=js&"
import style0 from "./RgpMaterials.vue?vue&type=style&index=0&id=2d6ad392&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6ad392",
  null
  
)

export default component.exports